import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { BookingPage } from './BookingPage'
import { BalanceRemindersPage } from './BalanceRemindersPage'
import { CustomQuoteSettingsPage } from './CustomQuoteSettingsPage'
import { EmbedWidgetSettingsPage } from './EmbedWidgetSettingsPage'
import { PaymentAtCheckoutCard } from './PaymentAtCheckoutCard'
import { useSettingsTab } from './useSettingsTab'

export function BookingSettingsPage() {
  const [tab, setTab] = useSettingsTab('booking')

  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList>
        <TabsTrigger value="booking">Booking</TabsTrigger>
        <TabsTrigger value="deposit-settings">Deposit Settings</TabsTrigger>
        <TabsTrigger value="custom-quotes">Custom Quote Settings</TabsTrigger>
        <TabsTrigger value="embed-widget">Embed Widget</TabsTrigger>
      </TabsList>

      <TabsContent value="booking">
        <BookingPage />
      </TabsContent>

      <TabsContent value="deposit-settings">
        <div className="space-y-6">
          <PaymentAtCheckoutCard />
          <BalanceRemindersPage />
        </div>
      </TabsContent>

      <TabsContent value="custom-quotes">
        <CustomQuoteSettingsPage />
      </TabsContent>

      <TabsContent value="embed-widget">
        <EmbedWidgetSettingsPage />
      </TabsContent>
    </Tabs>
  )
}
